// extracted by mini-css-extract-plugin
export default {"errorContainer":"BackgroundImage_errorContainer__LMHBB","errorIcon":"BackgroundImage_errorIcon__kc24r","loadingHolder":"BackgroundImage_loadingHolder__tU7jH"};